import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { useMemo } from "react";

import { useAdProducts } from "../apis";
import { ListAdProductsParams } from "../whatsappAdProducts.types";

const useAdProductsList = () => {
  const { page, setPage } = useManageTable();

  const requestParams: ListAdProductsParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT
    }),
    [page]
  );

  const { adProducts, totalItems, isLoading } = useAdProducts(requestParams);

  return {
    adProducts,
    totalItems,
    page,
    setPage,
    isLoading
  };
};

export default useAdProductsList;
